// react
import styled from 'styled-components';

interface LoaderProps {
  className?: string;
}

/**
 * Loader shows a loading animation.
 */
export const Loader = ({ className }: LoaderProps) => {
  return (
    <Wrapper className={className}>
      <Circle />
      <CircleCutout />
      <KeniWrapper />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${(props) => props.theme.spacing[64]};
`;

const Circle = styled.div`
  width: 161px;
  height: 161px;
  background: conic-gradient(
    rgba(149, 89, 225, 0),
    ${(props) => props.theme.color.surfaces.mediumPurple}
  );
  border-radius: 99999px;
  animation: circle 1.5s infinite linear;
  @keyframes circle {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const CircleCutout = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 130px;
  height: 130px;
  background: ${(props) => props.theme.color.neutral[10]};
  border-radius: 99999px;
`;

const KeniWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

Loader.displayName = 'Loader';

export default Loader;
